import { useGetTransferenciaById } from "data/api/gestao/transferencia/get-transferencia-by-id";
import { EnumStatusTransferencia } from "model/enums/enum-status-transferencia";
import { useCallback, useEffect, useRef, useState } from "react";
import { useCadastros } from "services/app/hooks/cadastros";
import { useShowAviso } from "services/app/hooks/show-aviso";
import { DefaultFormRefs } from "views/components/form/utils";
import { useThemeQueries } from "views/theme";
import { useStyles } from "./dialog-transferencia-styles";
import { DialogSaurus } from "../dialog-saurus/dialog-saurus";
import { guidEmpty } from "utils/guid-empty";
import { StatusTransferenciaMock } from "data/mocks/status-transacao-mock";
import { Box } from "@material-ui/core";
import { ContaBancariaConfiguracaoModel } from "model/api/gestao/conta-bancaria-configuracao/conta-bancaria-configuracao-model";
import { CadastroTransferencia } from "./components/cadastro-transferencia/cadastro-transferencia";
import { TransferenciaGetModel } from "model/api/gestao/transferencia/transferencia-get-model";
import { VisualizacaoTransferencia } from "./components/visualizacao-transferencia/visualizacao-transferencia";

interface DialogTransferenciaProps {
    id?: string;
    aberto: boolean;
}

export interface TransferenciaFormRef extends DefaultFormRefs<TransferenciaGetModel> {
    carregarDadosContaBancaria: (model: ContaBancariaConfiguracaoModel) => void;
}

export const DialogTransferencia = ({ id, aberto }: DialogTransferenciaProps) => {
    const { fecharDialogTransferencia } = useCadastros();
    const { showAviso } = useShowAviso();
    const { isMobile } = useThemeQueries();

    const { getTransferenciaById, carregando: carregandoGet } = useGetTransferenciaById();

    const carregando = carregandoGet

    const [transferencia, setTransferencia] = useState<TransferenciaGetModel>(new TransferenciaGetModel())

    const classes = useStyles({ status: transferencia.status as EnumStatusTransferencia });

    const formRef = useRef<TransferenciaFormRef>(null)

    const getTransferenciaWrapper = useCallback(async (id: string) => {
        try {
            const res = await getTransferenciaById(id);

            if (res.erro) throw res.erro
            if (!res.resultado?.data) return

            const data = res.resultado.data;

            setTransferencia(data)
        } catch (e: any) {
            showAviso('error', e.message)
        }
    }, [getTransferenciaById, showAviso])

    useEffect(() => {
        if (id) {
            const transferenciaFormModel = transferencia;
            formRef.current?.fillForm(transferenciaFormModel)
            if (transferencia.status === EnumStatusTransferencia.Rejeitada) {
                const mensagemErro = StatusTransferenciaMock.find((status) => status.Key === transferencia.status)
                showAviso('warning', mensagemErro?.Value || '', undefined, true)
            }
        }
    }, [id, showAviso, transferencia, transferencia.status])

    useEffect(() => {
        if (id)
            getTransferenciaWrapper(id);
    }, [getTransferenciaWrapper, id])


    return <DialogSaurus
        titulo={id ? 'Editar Transferência' : 'Adição de Transferência Manual'}
        tamanho='md'
        isDivider
        isButtonTitleClose
        aberto={aberto}
        fullScreen={isMobile}
        handleClickClose={fecharDialogTransferencia}
        endAdornment={id ?
            <Box className={classes.header}>
                {(transferencia.id !== guidEmpty()) && <Box className={classes.badgeStatus}>
                    {StatusTransferenciaMock.find(x => x.Key === transferencia.status)?.Value || 'Sem Status'}
                </Box>}
            </Box>
            : undefined}
    >
        {!id && <CadastroTransferencia formRef={formRef} carregando={carregando} />}
        {id && <VisualizacaoTransferencia formRef={formRef} carregando={carregando} transferencia={transferencia} />}
    </DialogSaurus>
}